import type { ReactNode } from "react";
import { LABEL_CLASS } from "@/shared/ui/primitives/field-styles";

export interface FieldFrameProps {
  id: string;
  label?: ReactNode;
  required?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
}

export function FieldFrame({ id, label, required, hint, error, children }: FieldFrameProps) {
  return (
    <div className="flex min-w-0 flex-col gap-[6px]">
      {label != null && (
        <label htmlFor={id} className={LABEL_CLASS}>
          {label}
          {required && <span className="ml-[3px] font-medium text-(--brand)">*</span>}
        </label>
      )}
      {children}
      {error != null ? (
        <p id={`${id}-error`} className="m-0 text-sm text-(--bad)">
          {error}
        </p>
      ) : hint != null ? (
        <p id={`${id}-hint`} className="m-0 text-sm leading-[1.45] text-(--muted)">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
